import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FieldConfigName} from '../../../models';
import {LabelInputDialogComponent} from './label-input-dialog.component';
import {FieldControlMaster} from '../control-master-label-required';

@Component({
  selector: 'app-label-input',
  templateUrl: './label-input.component.html',
  styleUrls: ['./label-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LabelInputComponent extends FieldControlMaster implements OnInit {
  @Output() labelInputUpdateControl = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() labelInputDelete = new EventEmitter<number>();
  dialogComponent = LabelInputDialogComponent;

  constructor() {
    super();
  }
  ngOnInit(): void {
  }
  onUpdatedControl(object) {
    this.labelInputUpdateControl.emit(object);
  }
  onDeletedControl(index: number) {
    this.labelInputDelete.emit(index);
  }
}
